<template>
  <div class="articles__container">
    <ArticleItem
      v-for="item of items"
      :id="item.id"
      :key="item.id"
      :title="item.article_title"
      :slug="item.article_slug"
      :thumbnail-url="item.article_thumbnail"
      :settings="settings"
    />
  </div>
</template>

<script>
import ArticleItem from './ArticleItem'
import articlesApiService from '../services/articlesApi.service'
import settingsApiService from '../../shared/services/settingsApi.service'

export default {
  name: 'ArticlesSection',
  components: {
    ArticleItem,
  },
  data() {
    return {
      items: [],
      settings: null,
    }
  },
  created() {
    this.fetchSettings()
  },
  methods: {
    fetchData() {
      articlesApiService
        .fetchAll(this.optional_params)
        .then((response) => {
          const responseData = response.data

          this.items = responseData.video_resources_articles
        })
        .catch(console.error)
    },
    fetchSettings() {
      settingsApiService
        .fetchSettings()
        .then((response) => {
          this.settings = response.data
        })
        .finally(() => {
          this.fetchData()
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.articles__container {
  padding-top: 16px;
  flex-wrap: wrap;
  display: flex;
}
</style>
